module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_planner@3x-c24699e2ae493e898b2e58d122b40988.webp";